export const pusherSubscription = {
  EVENT: 'pusher:subscription_succeeded',
  TIMEOUT: 2000, // 2 seconds
};

export const pusherPresence = {
  MEMBER_ADDED: 'pusher:member_added',
  MEMBER_REMOVED: 'pusher:member_removed',
};
